import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { EclipseOfferingApiClientContext } from '../eclipse-offering.context';
export const fetchProductDescriptionQueryFn = async props => {
  const {
    httpClient
  } = props;
  const {
    getProductDescription
  } = PremiumPurchasePlatformModule.SDK.ApiClient.queries({
    httpClient
  });
  const p3Context = EclipseOfferingApiClientContext.get('p3Context');
  if (!p3Context) {
    throw new Error('P3 context is required to fetch product description');
  }
  return getProductDescription({
    ...p3Context
  });
};
//# sourceMappingURL=fetch-product-description.query.js.map